import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FieldTitle from 'components/aor/FieldTitle';
import HeaderColumn from 'components/ui/table/HeaderColumn';
import Loader from 'components/loading/Loader';
import NoResults from 'components/form/styling/NoResults';
import Table from 'components/ui/table/Table';
import TableBodyCell from 'components/table/TableBodyCell';
import TableRow from 'components/ui/table/TableRow';
import TextField from 'components/show/TextField';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import utils from 'helpers/utils';

class AccountUserList extends Component {
    state = {
        users: null,
        loading: false,
    };

    componentDidMount() {
        this.fetchUsers();
    }

    componentDidUpdate(prevProps) {
        const {
            id,
        } = this.props;

        if (id !== prevProps.id) {
            this.fetchUsers();
        }
    }

    fetchUsers() {
        const {
            id,
            resource,
        } = this.props;

        this.setState({
            loading: true,
        });

        const url = `${ config.getApiBaseUrl() }/${ resource }/${ id }/users`;

        apiClient.read(url).then((response) => {
            this.setUsers(response);
        });
    }

    setUsers(response) {
        this.setState({
            loading: false,
            users: response,
        });
    }

    render() {
        const {
            link,
        } = this.props;

        const {
            users,
            loading,
        } = this.state;

        if (loading) {
            return <Loader />;
        }

        if (utils.isEmpty(users)) {
            return <NoResults label='resources.users.no_result'/>;
        }

        return (
            <Table responsive='scroll'>
                <TableRow>
                    <HeaderColumn style={ { width: '33%' } }>
                        <FieldTitle
                            source='lastname'
                            resource='users'
                        />
                    </HeaderColumn>
                    <HeaderColumn style={ { width: '33%' } }>
                        <FieldTitle
                            source='firstname'
                            resource='users'
                        />
                    </HeaderColumn>
                    <HeaderColumn style={ { width: '33%' } }>
                        <FieldTitle
                            source='email'
                            resource='users'
                        />
                    </HeaderColumn>
                </TableRow>

                {
                    utils.map(users, (user) => {
                        const {
                            id,
                            first_name,
                            last_name,
                            email,
                        } = user;

                        return (
                            <TableRow key={ `user-${ id }` }>
                                <TableBodyCell
                                    field={ <TextField value={ last_name } /> }
                                    link={ link }
                                    record={ user }
                                    resource='users'
                                    source='last_name'
                                />
                                <TableBodyCell
                                    field={ <TextField value={ first_name } /> }
                                    link={ link }
                                    record={ user }
                                    resource='users'
                                    source='first_name'
                                />
                                <TableBodyCell
                                    field={ <TextField value={ email } /> }
                                    link={ link }
                                    record={ user }
                                    resource='users'
                                    source='email'
                                />
                            </TableRow>
                        );
                    })
                }
            </Table>
        );
    }
}

AccountUserList.defaultProps = {
    link: 'show',
};

AccountUserList.propTypes = {
    id: PropTypes.number.isRequired,
    link: PropTypes.string,
    resource: PropTypes.string.isRequired,
};

export default AccountUserList;


// WEBPACK FOOTER //
// ./src/pages/accounts/show/AccountUserList.js